import { DateTime } from 'luxon'

import { dateTimeFormats } from '../../../../../../shared/functions/Date/date.functions'

export const formatDayNameCapitalized = (dayName: string): string => {
  if (!dayName) return dayName

  return dayName.charAt(0).toUpperCase() + dayName.slice(1).toLowerCase()
}

export const formatTimeTo12Hour = (time24: string): string => {
  if (!time24) return time24

  const parsed = DateTime.fromFormat(time24, 'HH:mm')

  if (!parsed.isValid) return time24

  return parsed.toFormat(dateTimeFormats.time.short)
}
